class ProductUpsellPack extends HTMLElement {
  constructor() {
    super();
    this.mainVariantSelector = this.querySelector(
      ".product__form__select--hidden"
    );
    this.optionsSelectors = this.querySelectorAll(
      ".pup-product__selector .product__form__select"
    );
    this.optionsSelectors.forEach((optionSelector) => {
      optionSelector.addEventListener(
        "change",
        this.updateMainVariant.bind(this)
      );
    });
    this.formVariantId = this.querySelector('input[name="product-id"]');
    this.addToCartButton = this.querySelector('button[name="add"]');
    this.content = this.querySelector(".pup-content");
    this.showMoreButton = this.querySelector(".pup-show-more");
    this.showMoreButton.addEventListener("click", this.showMore.bind(this));
  }
  updateMainVariant() {
    let selectedOptions = [];
    this.optionsSelectors.forEach((optionSelector) => {
      selectedOptions.push(optionSelector.value);
    });

    // Construit le sélecteur en fonction du nombre d'options sélectionnées
    let selectorQuery = selectedOptions
      .map((option, index) => `[option-${index + 1}="${option}"]`)
      .join("");

    // Trouve l'option correspondante
    let selectedOption = this.mainVariantSelector.querySelector(
      `option${selectorQuery}`
    );

    if (selectedOption) {
      this.mainVariantSelector.value = selectedOption.value;
      selectedOption.selected = true;
      this.formVariantId.value = selectedOption.value;
      this.updatePrices(selectedOption);
      this.updateButtonStatus(selectedOption);
    } else {
      console.error("No matching variant found");
    }
  }
  updatePrices(selectedOption) {
    this.addToCartButton.innerHTML = `${
      window.theme.strings.addToCart
    } • <span class="pup-product-prices">${selectedOption.dataset.price} ${
      selectedOption.dataset.compareAtPrice
        ? `<s>${selectedOption.dataset.compareAtPrice}<s>`
        : ""
    }</span>`;
  }
  updateButtonStatus(selectedOption) {
    if (selectedOption.dataset.available == "true") {
      this.addToCartButton.removeAttribute("disabled");
    } else {
      this.addToCartButton.innerHTML = window.theme.strings.unavailable;
      this.addToCartButton.setAttribute("disabled", "disabled");
    }
  }
  showMore() {
    this.content.classList.toggle("pup-content--expanded");
    if (this.content.classList.contains('pup-content--expanded')) {
      this.showMoreButton.textContent = this.showMoreButton.dataset.openedText;
    } else {
      this.showMoreButton.textContent = this.showMoreButton.dataset.initialText;
    }
  }
}
customElements.define("product-upsell-pack", ProductUpsellPack);

function trackIntelligemsEvent(event) {
  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    "event": event
  })
}

const btnUpsellPack = document.querySelector(".btn-upsell-pack");
if(btnUpsellPack){
  btnUpsellPack.addEventListener("click", () => {
    trackIntelligemsEvent("upsell pack added");
  });
}

class ProductUpsells extends HTMLElement {
  constructor() {
    super();

    let selectors = {
      upsellSlider: '[data-flickity]',
      upsellSliderData: 'flickity',
      pupShowMore: '.pup-show-more'
    };

    this.selectors = selectors;

    this.init();
  }

  async init() {
    if (this.querySelector(this.selectors.upsellSlider) !== null) {
      let sliderConfig = this.querySelector(this.selectors.upsellSlider).dataset[this.selectors.upsellSliderData];
      this.slider = new themeVendor.Flickity(this.querySelector(this.selectors.upsellSlider), {
        ...JSON.parse(sliderConfig),
        adaptiveHeight: true
      });

      let pupShowMoreButtons = this.querySelectorAll(this.selectors.pupShowMore);
      var self = this;
      pupShowMoreButtons.forEach(function (button, index) {
        button.addEventListener('click', self.refreshSlider.bind(self));
      });
    }
  }

  refreshSlider(event) {
    if (this.slider) {
      this.slider.resize();
    }
  }
}
customElements.define("product-upsells", ProductUpsells);